import gql from 'graphql-tag';

export const slackChannelFragment = gql`
  fragment slackChannelFragment on SlackChannel {
    dokkioClass
    slackChannelType
    remoteID
    name
    isArchived
  }
`;
export default slackChannelFragment;
